import React from 'react';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  return (
    <section className="section">
      <h2>Contact</h2>
      <ContactForm />
      <div className="card">
        <strong>Coordonnées</strong>
        <p>
          <img src="/assets/tn-flag.svg" alt="TN Flag" style={{ height: '1em', verticalAlign: 'middle' }} />
          &nbsp; : +216 94 94 99 02<br />
          <img src="/assets/fr-flag.svg" alt="FR Flag" style={{ height: '1em', verticalAlign: 'middle' }} />
          &nbsp; : +33 6 05 00 10 13<br />
          Email : contact@rokatc.com<br />
          Adresse : Sousse, Tunisie
        </p>
      </div>
    </section>
  );
};

export default Contact;
